var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h--100 flex flex-column"},[_c('Nuxt',{staticClass:"flex-grow-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }